import React, { Component } from 'react';
import * as Progress from 'react-native-progress';
import { StyleSheet, View, Platform } from 'react-native';
import { Input, Button, Colors, Text } from '../components';

class ConsultationStartProgressBar extends Component {

  constructor(props) {
    super(props);
    this.state = {

    }
  }

  render_progress_tabs = (current_step, total_steps) => {

    let tabs           = [];
    let active_tab_clr = this.props.color || Colors.PRIMARY;

    for (let i = 0; i < total_steps; i++) {
      let bg_color = i < current_step ? active_tab_clr : '#d8d8d8';
      tabs.push(<View key={i} style={{ flex: 1, backgroundColor: bg_color, marginRight: 5, marginLeft: 5, borderRadius: 10, height: 5 }}></View>)
    }

    return <View style={{ flex: 1, flexDirection: 'row', alignItems: 'center' }}>
      { tabs }
    </View>
  }

  render() {
    let total_steps  = this.props.total_steps;
    let current_step = this.props.current_step;
    return (
      <View style={styles.main_container}>
        <View>
          <Text style={{ fontWeight: 'bold', fontWeight: '500', fontSize: 16, color: '#575762' }}>{ current_step + ' of ' + total_steps }</Text>
        </View>
        <View style={{ flex: 1, paddingLeft: 20 }}>
          { this.render_progress_tabs(current_step, total_steps) }
        </View>
      </View>
    );
  }

}

const styles = StyleSheet.create({
  main_container: {
    flexDirection: 'row',
    padding: 20,
  }
});

export default ConsultationStartProgressBar
